import { useEffect, useRef } from 'react';
import { Toast } from '@/components/ui/toast';
import { useCartStore } from '@/features/cart/stores/cart-store';

export function CartErrorToast() {
  const lastError = useCartStore((state) => state.lastError);
  const setError = useCartStore((state) => state.setError);
  const shownAtRef = useRef<string | null>(null);

  useEffect(() => {
    if (!lastError) {
      shownAtRef.current = null;
      return;
    }

    // Deduplicate identical errors in a short window to avoid “toast spam”
    if (shownAtRef.current === lastError) {
      return;
    }

    shownAtRef.current = lastError;
  }, [lastError]);

  if (!lastError) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 z-50 w-full max-w-sm pointer-events-none">
      <div className="pointer-events-auto animate-slide-up">
        <Toast
          variant="error"
          title="Couldn’t add to cart"
          description={lastError}
          duration={4500}
          onDismiss={() => setError(undefined)}
        />
      </div>
    </div>
  );
}

export default CartErrorToast;

